import {make} from 'vuex-pathify'
import Vue from 'vue'
import {ptracGetEntities} from '@/utilities/ptracApi'
import {crudifyMutations} from '@/utilities/vuex2'

const initialState = {
    results: []
}

const state = Vue.util.extend({}, JSON.parse(JSON.stringify(initialState)))

const getters = make.getters(state)
const mutations = make.mutations(state)
crudifyMutations(mutations)

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions: {
        async fetchAll({state}) {
            state.results = []
            const response = await ptracGetEntities('supply-pro-purchase-orders/findAllNotEnteredCombined')
            for (const purchaseOrder of response.data) {
                state.results.push(purchaseOrder)
            }
        }
    }
}